module.exports = __webpack_public_path__ + "img/about-career-3.488a0899.jpg";